import { z } from 'zod';

export const GENDER_OPTIONS = [
  { value: 'MALE', label: 'Masculino' },
  { value: 'FEMALE', label: 'Femenino' },
  { value: 'OTHER', label: 'Otro' },
] as const;

export const COMPENSATION_PLAN_OPTIONS = [
  { value: 'A', label: 'Plan A' },
  { value: 'B', label: 'Plan B' },
] as const;

export const beneficiarySchema = z.object({
  date_of_birth: z
    .string()
    .min(1, 'Requerido')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
  duration_years: z.coerce.number().int().positive('Debe ser > 0'),
  annual_tuition: z.coerce.number().nonnegative('Debe ser ≥ 0'),
});

export type Beneficiary = z.infer<typeof beneficiarySchema>;

export const insuredUniversitySchema = z.object({
  date_of_birth: z
    .string()
    .min(1, 'Requerido')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
  gender: z.enum(['MALE', 'FEMALE', 'OTHER']),
  projection_rate: z.coerce.number().positive('Debe ser > 0'),
  compensation_plan: z.enum(['A', 'B']),
  death_insured_capital: z.coerce.number().nonnegative(),
  accidental_death_insured_capital: z.coerce.number().nonnegative(),
  itp_insured_capital: z.coerce.number().nonnegative(),
  serious_illness_insured_capital: z.coerce.number().nonnegative(),
});

export type InsuredUniversityFormValues = z.infer<typeof insuredUniversitySchema>;

export const insuredUniversityDefaults: InsuredUniversityFormValues = {
  date_of_birth: '1990-01-01',
  gender: 'MALE',
  projection_rate: 0.0331,
  compensation_plan: 'A',
  death_insured_capital: 1000,
  accidental_death_insured_capital: 0,
  itp_insured_capital: 0,
  serious_illness_insured_capital: 0,
};

export const beneficiaryDefaults: Beneficiary = {
  date_of_birth: '2009-06-01',
  duration_years: 4,
  annual_tuition: 30,
};
